// src/components/TZ/nameRes/SearchForm.jsx
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, InputNumber, Button, message } from 'antd';
import { FileSearchOutlined } from '@ant-design/icons';
import { useSocketContext } from '../../../sockets/SocketContext';
import { setWipoLastSearchQuery } from '../../../store/wipoSlice';
import { setLastSearchQuery, setFormValues } from '../../../store/tz/reducer';
import MktuClassSelector from '../../common/MktuClassSelector';
import normalizeMktu from '../../../utils/normalizeMktu';

const SearchForm = ({ setLocalState }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const savedValues = useSelector((s) => s.tz.forms.name);
  const { createNewTaskOnServer } = useSocketContext();

  // Обработчик сабмита формы
  const handleFinish = async (values) => {
    const { name, quantity, mktu } = values;
    const normalizedMktu = normalizeMktu(mktu);
    // Сохраняем последний запрос в Redux
    dispatch(setLastSearchQuery(name));
    
    // Обновляем локальное состояние, если передан setLocalState
    if (setLocalState) {
      setLocalState(prev => ({
        ...prev,
        searchQuery: name,
        quantity,
        mktu
      }));
    }

    // Объединённый поиск (стандарт + фонетика) — всегда по умолчанию
    const taskDesc = { name, quantity, mktu, is_phonetic: ['true'] };
    const taskDescriptionReq = { requests: name, quantity, mktu, is_phonetic: ['true'] };
    const wipoTask = { wipoName: name, quantity, mktu: normalizedMktu, is_phonetic: ['true'] };
    // Отправляем три задачи и показываем единое сообщение об успехе, а об ошибках — только для упавших
    dispatch(setWipoLastSearchQuery(name));
    const jobs = [
      { desc: taskDesc,           type: 'name',      label: 'ТЗ' },
      { desc: taskDescriptionReq, type: 'requests',  label: 'заявки' },
      { desc: wipoTask,           type: 'wipoName',  label: 'WIPO' },
    ];
    const results = await Promise.all(jobs.map(j => new Promise((resolve) => {
      createNewTaskOnServer(j.desc, j.type, (err) => resolve({ label: j.label, err }));
    })));
    const failed = results.filter(r => r.err);
    if (failed.length === 0) {
      message.success('Все запросы отправлены');
    } else {
      failed.forEach(r => message.error(`Не удалось создать задачу ${r.label}`));
    }
  };

  useEffect(() => {
    form.setFieldsValue(savedValues);
  }, [form, savedValues]);

  return (
    <Form
      form={form}
      layout="inline"
      onFinish={handleFinish}
      onValuesChange={(_, all) => dispatch(setFormValues({ formKey: 'name', values: all }))}
      style={{ marginBottom: 16, flexWrap: 'wrap' }}
    >
      <Form.Item
        name="name"
        label="Название"
        rules={[{ required: true, message: 'Введите название' }]}
      >
        <Input placeholder="Введите название" style={{ width: '100%', maxWidth: 280, minWidth: 0 }} />
      </Form.Item>
      <Form.Item name="mktu" label="Класс МКТУ">
        <MktuClassSelector placeholder="МКТУ" />
      </Form.Item>
      <Form.Item name="quantity" label="Количество" initialValue={20}>
        <InputNumber min={1} max={200} style={{ width: 80 }} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" icon={<FileSearchOutlined />}>
          Найти
        </Button>
      </Form.Item>
    </Form>
  );
};

export default SearchForm;
